export const i18nConfig = {
  locale: "en",
  fallback_locale: "en",
  supported_locale: "en,es,zh-CN"
};



// WEBPACK FOOTER //
// ./src/config/i18n.js